import { combineReducers } from '@reduxjs/toolkit'
import authReducer from 'app/authSlice'
import cartReducer from 'features/Cart/CartSlice'
import categoryReducer from 'features/Category/categorySlice'
import dashboardReducer from 'features/Dashboard/dashboardSlice'
import { invoiceFromPosReducer } from 'features/Invoice/screens/ListInvoiceFromPOS/invoiceFromPosSlice'
import { transactionSlice } from 'features/Invoice/screens/ListTransactions/slice'
import invoiceApprovalProcessReducer from 'features/System/screens/InvoiceApprovalProcess/invoiceApprovalProcessSlice'
import orderReducer from 'features/System/screens/ResourceManagement/orderSlice.js'
import systemConfigReducer from 'features/System/screens/SystemConfiguration/SystemConfigurationSlice.js'
import functionReducer from 'features/System/screens/UserManagement/functionSlice.js'
import userReducer from 'features/System/screens/UserManagement/userSlice.js'
import systemReducer from 'features/System/systemSlice'
import importTicketReducer from 'features/Ticket/screens/ImportTicket/importTicketSlice'
import invoiceReducer from '../features/Invoice/invoiceSlice'
import reportReducer from '../features/Report/reportSlice'
import templateInvoiceReducer from '../features/TemplateInvoice/templateInvoiceSlice'
import ticketReducer from '../features/Ticket/ticketSlice'
import appReducer from './appSlice'
import filterReducer from './filterSlice'
import TableReducer from './tableSettingSlice'
import toolReducer from './toolSlice'

export default combineReducers({
  app: appReducer,
  report: reportReducer,
  templateInvoice: templateInvoiceReducer,
  auth: authReducer,
  system: systemReducer,
  dashboard: dashboardReducer,
  category: categoryReducer,
  tool: toolReducer,
  invoice: invoiceReducer,
  cart: cartReducer,
  systemConfig: systemConfigReducer,
  function: functionReducer,
  userList: userReducer,
  orders: orderReducer,
  invoiceApprovalProcess: invoiceApprovalProcessReducer,
  filter: filterReducer,
  ticket: ticketReducer,
  table: TableReducer,
  importTicket: importTicketReducer,
  [transactionSlice.name]: transactionSlice.reducer,
  invoiceFromPos: invoiceFromPosReducer,
})
